import { get } from "app/utils/axios/kheti";
import { UserHistoryResponse } from "../models/diagnosis";

const fetchUserHistory = async (
  page: number,
  pageSize: number,
  farmerId: number | null,
  start?: number,
  end?: number
) => {
  try {
    let query = `farmer=${farmerId}&page=${page}&page_size=${pageSize}`;

    if (start !== undefined && end !== undefined) {
      query += `&start=${start}&end=${end}`;
    }

    const response = await get<UserHistoryResponse>(
      `/plantix/v1/history?${query}`
    );

    return response;
  } catch (e) {
    return null;
  }
};

export default fetchUserHistory;
